<template>
  <div class="users-layout">
    <default-box
        :loader="loading">
      <div class="d-flex justify-content-between align-items-center mb-10">
        <div class="row col-md-8 align-items-center justify-content-start row-column">
          <div class="col-md-4">
            <search-input
                class="search-input"
                :value="search"
                :placeholder="$t('inputs.search')"
                @change="searchFetchList"
            />
          </div>
          <div class="col-md-4">
            <default-select
                :selected_val="selectedCategory"
                :placeholder="$t('articles.category')"
                :display_placeholder="false"
                display_item_api_key="title"
                :list_outer="categories"
                @change="changeCategory"
            />
          </div>
        </div>
      </div>
      <tables-slot
          :empty_spacer="loading"
          @paginationFetch="fillData"
          @popstateEvent="fetchList"
          :pagination="pagination">
        <template v-slot:table_head>
          <td class="w-0 text-nowrap">#</td>
          <td class="w-0 text-nowrap">{{ $t('tables.title') }}</td>
          <td class="w-0 text-nowrap">{{ $t('tables.download') }}</td>
        </template>
        <template v-slot:table_body>
          <tr v-for="item in list">
            <td class="w-0 text-nowrap">
              {{ item.id }}
            </td>
            <td class="w-0 text-nowrap">
              <span>
                {{ item.title }}
              </span>
            </td>
            <td class="w-0 text-nowrap">
              <eye-icon>Download</eye-icon>
            </td>
          </tr>
        </template>
      </tables-slot>
    </default-box>
  </div>
</template>

<script>

import {axiosDocuments} from "../../../helpers/axios_requests";
import {REPLACE_IN_QUERY, REPLACE_STATE} from "../../../helpers/url_helper";
import routes_mixin from "../../../mixins/routes_mixin";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import TablesSlot from "../../small_components/tables/TablesSlot.vue";
import Switcher from "../../small_components/Switcher.vue";
import EditIcon from "../../icons/EditIcon.vue";
import DefaultBox from "../../slots/DefaultBox.vue";
import SearchInput from "../../small_components/SearchInput.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import CloseIcon from "../../icons/CloseIcon.vue";
import DefaultButton from "../../small_components/DefaultButton.vue";
import LogoutIcon from "../../icons/LogoutIcon.vue";
import DefaultSelect from "../../small_components/DefaultSelect.vue";
import EyeIcon from "../../icons/EyeIcon.vue";

export default {
  name: 'DocumentsUserLayout',
  mixins: [routes_mixin],
  components: {
    EyeIcon,
    DefaultSelect,
    LogoutIcon,
    DefaultButton,
    CloseIcon,
    DefaultInput,
    SearchInput,
    DefaultBox,
    EditIcon,
    Switcher,
    TablesSlot,
    RouterLinkTo,
  },
  computed: {

  },
  beforeMount() {
    this.fetchList()
    this.fetchCategories()
  },
  data() {
    return {
      list: [],
      pagination: [],
      loading: false,
      search: '',
      categories: [],
      selectedCategory: [],
    }
  },
  methods: {
    searchFetchList(e) {
      this.search = e.target.value
      REPLACE_STATE(
          REPLACE_IN_QUERY(location.search, 'search', this.search)
      )
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      axiosDocuments.list({
        search: this.search,
        blog: true,
        category_id: this.selectedCategory.id
      })
          .then(r => this.fillData(r.data))
          .finally(() => {
            this.loading = false
          })
    },
    fillData({collection, pagination}) {
      this.list = collection || []
      this.pagination = pagination || []
    },
    fetchCategories() {
      axiosDocuments.getCategories()
          .then(r => {
            this.categories = r.data.collection;
          })
          .finally(() => {
            this.loading = false
          })
    },
    changeCategory(value){
      this.selectedCategory = value
      this.fetchList()
    },
  }
}
</script>
